import { useState, useEffect } from 'react';
import axios from '../../axios';
import config from '../../config';
import SellerData from './SellerData';
import styles from './sellerData.module.css';

function SellerDashboard() {
  const [sellerData, setSellerData] = useState([]);
  const backend_url = config.backend_url;

  useEffect(() => {
    // Always fetch fresh seller data from the backend
    fetchSellerData();
  }, [backend_url]);

  const fetchSellerData = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/seller-data`, {
        withCredentials: true,
      });
      setSellerData(response.data);
    } catch (error) {
      console.error('Error fetching seller data:', error);
    }
  };

  const handleDelete = async (dataId) => {
    try {
      await axios.delete(`${backend_url}/api/delete-seller-data/${dataId}`, {
        withCredentials: true,
      });
      
      // Remove the deleted item from the state
      const updatedSellerData = sellerData.filter(item => item.id !== dataId);
      setSellerData(updatedSellerData);
    } catch (error) {
      console.error('Error deleting seller data:', error);
    }
  };

  return (
    <div className={styles.dashboardContainer}>
      <div className={styles.dashboardHeader}>
        <h1>Mina Annonser</h1>
        <p className={styles.subtitle}>Hantera dina annonser och se deras status</p>
      </div>
      <div className={styles.dashboardContent}>
        <SellerData data={sellerData} onDelete={handleDelete} />
      </div>
    </div>
  );
}

export default SellerDashboard;
